import "./ticket.css";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import plusIcon from "../../assets/icons/plus.svg";
import refreshIcon from "../../assets/icons/refresh.png";
// import exportIcon from "../../assets/icons/export.png";
import excelIcon from "../../assets/icons/excelIcon.png";
import fileIcon from "../../assets/icons/fileIcon.png";
import closeIcon from "../../assets/icons/close.png";
import downloadButton from "../../assets/icons/downloading.png";
import filterIcon from "../../assets/icons/filter.png";
import clickIcon from "../../assets/icons/tap.png";
import backIcon from "../../assets/icons/back.png";
import { showSuccess, showError } from "../../components/ui/toast";
import downloadIcon from "../../assets/icons/download.png";
import editIcon from "../../assets/icons/edit.png";
import { useEffect, useState, useCallback, useRef } from "react";
import API from "../../services/api";

import { getUser } from "../../services/authStore";

export default function Ticket() {
  const user = getUser() || {};
  const companyId = user?.company_id;
  const userId = user?.user_id;
  const role = user?.role;
  const email = user?.user_email;

  /* ================= STATES ================= */

  const [statusList, setStatusList] = useState([]);
  const [ticketList, setTicketList] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const [page, setPage] = useState(1);
  const [pageSize] = useState(10); // Changed from 25 to 10
  const [hasMore, setHasMore] = useState(true);

  const [loading, setLoading] = useState(false);
  const [typeList, setTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showMobileRightPanel, setShowMobileRightPanel] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [replyMessage, setReplyMessage] = useState("");
  const [replyFiles, setReplyFiles] = useState([]);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [externalAuth, setExternalAuth] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const [creating, setCreating] = useState(false);
  const [sending, setSending] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const listRef = useRef(null);
  const [isUnassigned, setIsUnassigned] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const isImage = previewFile?.match(/\.(png|jpg|jpeg)$/i);

  const isPdf = previewFile?.match(/\.pdf$/i);

  const isExcel = previewFile?.match(/\.(xls|xlsx|csv)$/i);
  const [previewUrl, setPreviewUrl] = useState(null);
  const statusFromDashboard = location.state?.statusId;
  const [formData, setFormData] = useState({
    subject: "",
    description: "",
    priority: "",
    type_id: "",
    category_id: "",
    status_id: "",
    attachment: null,
    reported_user: "",
    assigned_users: [],
    // no need to predefine custom fields (dynamic)
  });

  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [filters, setFilters] = useState({
    customer: "",
    type: "",
    category: "",
    priority: "",
  });

  const [appliedFilters, setAppliedFilters] = useState({
    customer: "",
    type: "",
    category: "",
    priority: "",
  });
  const handleClearFilters = () => {
    const emptyFilters = {
      customer: "",
      type: "",
      category: "",
      priority: "",
    };

    setFilters(emptyFilters);
    setAppliedFilters(emptyFilters);
    setPage(1);
    setHasMore(true);
    setTicketList([]);
  };
  const canEditAssignedUsers =
    role === "super_admin" ||
    role === "support_admin" ||
    role === "client_admin" ||
    role === "client_agent";
  const isNewTicket = !selectedTicket?.id;

  const canEditPriority =
    isNewTicket ||
    role === "super_admin" ||
    role === "support_admin" ||
    role === "client_admin" ||
    role === "client_agent";

  const selectedTypeObj = typeList.find(
    (t) =>
      String(t.id) === String(selectedTicket?.type || selectedTicket?.type_id),
  );

  const hideAssignUsers =
    selectedTypeObj?.isglobal === 1 &&
    (role === "client_admin" || role === "client_agent");

  // then filter statuses
  const filteredStatus = statusList.filter((status) => {
    if (!selectedTypeObj) return true;

    if (selectedTypeObj.isglobal === 1) {
      return status.isglobal === 1;
    }

    return true;
  });
  useEffect(() => {
    if (location.state?.openCreateForm) {
      setSelectedTicket(null);
      setShowCreateForm(true);
      setIsEditing(false);
      setShowMobileRightPanel(true); // optional for mobile
    }
  }, [location.state]);
  const handleRefresh = () => {
    setFilters({
      customer: "",
      type: "",
      category: "",
      priority: "",
    });

    setAppliedFilters({
      customer: "",
      type: "",
      category: "",
      priority: "",
    });

    setSelectedStatuses([]);
    setPage(1);
    setHasMore(true);
    setTicketList([]);
  };
  const handleUnassignedFilter = () => {
    setIsUnassigned((prev) => !prev);
    setPage(1);
    setHasMore(true);
    setTicketList([]);
  };
  const fetchCustomFields = useCallback(async () => {
    try {
      const res = await API.get(`/settings/custom-fields/`, {
        params: {
          company_id: companyId,
        },
      });

      setCustomFields(res?.data || []);
    } catch (error) {
      console.error("Custom Fields API Error:", error);
    }
  }, [companyId]);
  const getCompanySettings = async () => {
    try {
      const res = await API.get(`/settings/company/${companyId}`);

      return res?.data;
    } catch (error) {
      console.error("Company settings error", error);
      return null;
    }
  };
  const fetchCompanies = async () => {
    try {
      const res = await API.get("/settings/company/");
      setCompanyList(res?.data || []);
    } catch (err) {
      console.error("Company API error", err);
    }
  };
  useEffect(() => {
    fetchCompanies();
  }, []);
  const generateToken = async () => {
    try {
      const company = await getCompanySettings();

      if (!company) return null;

      const params = new URLSearchParams();
      params.append("username", company.username);
      params.append("password", company.password);

      const baseUrl = company.url.startsWith("http")
        ? company.url
        : `https://${company.url}`;

      const res = await fetch(`${baseUrl}/api/generate_token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });

      const data = await res.json();
      if (!data?.access_token) {
        throw new Error("Token not received");
      }

      return {
        token: data?.access_token,
        baseUrl: baseUrl,
      };
    } catch (error) {
      console.error("Token generation error", error);
      return null;
    }
  };
  const getAuthData = async () => {
    if (externalAuth) return externalAuth;

    const data = await generateToken();
    setExternalAuth(data);
    return data;
  };
  const fetchExternalUsers = async () => {
    try {
      const authData = await getAuthData();
      if (!authData) return;

      const res = await fetch(
        `${authData.baseUrl}/api/get_users?helpdesk=true`,
        {
          headers: {
            Authorization: `Bearer ${authData.token}`,
          },
        },
      );

      if (res.status === 401) {
        setExternalAuth(null);
        return fetchExternalUsers(0);
      }

      const data = await res.json();

      if (data?.users) {
        setUserList(data.users);

        if (selectedTicket?.assigned_users?.length > 0) {
          const assignedName =
            selectedTicket.assigned_users[0].assign_to_username;

          const matchedUser = data.users.find(
            (u) =>
              u.name &&
              u.name.toLowerCase().trim() ===
                assignedName?.toLowerCase().trim(),
          );

          if (matchedUser) {
            setFormData((prev) => ({
              ...prev,
              assigned_users: [matchedUser.id],
            }));
          }
        }
      } else {
        setUserList([]);
      }
    } catch (error) {
      console.error("External user API error", error);
      setUserList([]);
    }
  };

  const formatFullDate = (dateString) => {
    if (!dateString) return "-";

    // Ensure the input is treated as UTC
    const utcDate = new Date(
      dateString.endsWith("Z") ? dateString : dateString + "Z",
    );

    return utcDate.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };
  const formatColor = (color) => {
    if (!color) return "#f3f4f6";
    return color.startsWith("#") ? color : `#${color}`;
  };

  const handleStatusFilter = (statusId) => {
    let updatedStatuses = [];

    if (selectedStatuses.includes(statusId)) {
      updatedStatuses = selectedStatuses.filter((id) => id !== statusId);
    } else {
      updatedStatuses = [...selectedStatuses, statusId];
    }

    setSelectedStatuses(updatedStatuses);
    setPage(1);
    setHasMore(true);
    setTicketList([]);
  };

  const getStatusDetails = (statusId) => {
    return statusList.find((s) => String(s.id) === String(statusId));
  };
  const handleEditClick = async () => {
    setIsEditing(true);
    setShowCreateForm(true);

    let customFieldData = {};

    //  Extract custom field values from selectedTicket
    if (selectedTicket?.custom_fields?.length > 0) {
      selectedTicket.custom_fields.forEach((cf) => {
        customFieldData[`custom_${cf.field_id}`] = cf.value || "";
      });
    }

    setFormData({
      id: selectedTicket.id,
      subject: selectedTicket.subject || "",
      description: selectedTicket.description || "",
      priority: selectedTicket.priority || "",
      type_id: selectedTicket.type || "",
      category_id: selectedTicket.category || "",
      status_id: selectedTicket.status || "",
      assigned_users:
        selectedTicket.assigned_users?.map((u) => u.assign_to_user_id) || [],
      attachment: null,

      //  ADD THIS (IMPORTANT)
      ...customFieldData,
    });
  };
  const fetchConversations = async (ticketId) => {
    try {
      const res = await API.get(
        `/tickets/${companyId}/${userId}/${role}/${ticketId}/conversations`,
      );

      setConversations(res.data || []);
      return res;
    } catch (error) {
      console.error("Conversation fetch error", error);
    }
  };
  const handleSendReply = async () => {
    if (isClosedTicket) {
      showError("This ticket is closed");
      return;
    }
    if (sending) return;

    // ✅ Message is compulsory
    if (!replyMessage.trim()) {
      showError("Message is required");
      return;
    }

    try {
      setSending(true);

      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("username", user?.username || "");
      formData.append("message", replyMessage);

      // ✅ Attachment optional
      if (replyFiles.length > 0) {
        formData.append("file", replyFiles[0]);
      }

      await API.post(
        `/tickets/${companyId}/${selectedTicket.id}/conversation`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      showSuccess("Reply added successfully");

      setReplyMessage("");
      setReplyFiles([]);

      fetchConversations(selectedTicket.id);
    } catch (error) {
      console.error("Reply error", error);
      showError("Reply failed");
    } finally {
      setSending(false);
    }
  };

  const handleDownloadAttachment = async () => {
    try {
      const response = await API.get(
        `/tickets/${companyId}/${role}/download/${selectedTicket.id}`,
        {
          responseType: "blob",
        },
      );

      const file = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(file);

      setPreviewFile(selectedTicket.attachment);
      setPreviewUrl(url);
    } catch (error) {
      console.error("Preview failed", error);
    }
  };
  const handleConversationDownload = async (conversationId, fileName) => {
    try {
      const response = await API.get(
        `/tickets/${companyId}/${role}/conversation-download/${conversationId}`,
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      const cleanName = fileName?.replace(/^\d+_/, "") || "file";

      link.download = cleanName;

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Conversation download failed", error);
    }
  };
  const getTimeAgo = (dateString) => {
    if (!dateString) return "";

    //  Ensure UTC parsing
    const created = new Date(
      dateString.endsWith("Z") ? dateString : dateString + "Z",
    );

    const now = new Date();

    const diff = Math.floor((now - created) / 1000);

    if (diff < 60) return "Just now";

    const units = [
      { label: "year", seconds: 31536000 },
      { label: "month", seconds: 2592000 },
      { label: "week", seconds: 604800 },
      { label: "day", seconds: 86400 },
      { label: "hour", seconds: 3600 },
      { label: "minute", seconds: 60 },
    ];

    for (let unit of units) {
      const value = Math.floor(diff / unit.seconds);
      if (value > 0) {
        return `${value} ${unit.label}${value > 1 ? "s" : ""} ago`;
      }
    }

    return "Just now";
  };
  const getTypeDetails = (id) => {
    return typeList.find((t) => String(t.id) === String(id));
  };

  const getCategoryDetails = (id) => {
    return categoryList.find((c) => String(c.id) === String(id));
  };

  const filteredCategories = categoryList.filter(
    (cat) => String(cat.type_id) === String(formData.type_id),
  );
  const fetchSettings = useCallback(async () => {
    try {
      const responses = await Promise.all([
        API.get(`/settings/types/active/${companyId}`),
        API.get(`/settings/status/active/${companyId}`),
        API.get(`/settings/categories/active/${companyId}`),
      ]);

      setTypeList(responses[0]?.data || []);
      setStatusList(responses[1]?.data || []);
      setCategoryList(responses[2]?.data || []);
    } catch (error) {
      console.error("Settings API Error:", error);
    }
  }, [companyId]);
  const fetchApis = useCallback(async () => {
    try {
      setLoading(true);

      const res = await API.get(`/tickets/${companyId}/${userId}/${role}`, {
        params: {
          page,
          page_size: pageSize,
          status:
            selectedStatuses.length > 0
              ? selectedStatuses.join(",")
              : undefined,
          type: appliedFilters.type || undefined,
          category: appliedFilters.category || undefined,
          priority: appliedFilters.priority || undefined,
          company: appliedFilters.customer || undefined,
          unassigned: isUnassigned,
        },
      });

      const ticketResponse = res?.data;
      const newTickets = ticketResponse?.data || [];

      // ✅ APPEND logic for load more
      setTicketList((prev) => {
        if (page === 1) return newTickets; // First page - replace
        // Subsequent pages - append without duplicates
        const existingIds = new Set(prev.map((t) => t.id));
        const filtered = newTickets.filter((t) => !existingIds.has(t.id));
        return [...prev, ...filtered];
      });

      // ✅ Check if more tickets exist
      setHasMore(newTickets.length === pageSize);
    } catch (error) {
      console.error("Ticket API Error:", error);
    } finally {
      setLoading(false);
    }
  }, [
    companyId,
    userId,
    role,
    page,
    pageSize,
    selectedStatuses,
    appliedFilters,
    isUnassigned,
  ]);
  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  useEffect(() => {
    fetchApis();
  }, [fetchApis]);

  useEffect(() => {
    fetchCustomFields();
  }, [fetchCustomFields]);
  useEffect(() => {
    if (statusFromDashboard) {
      setSelectedStatuses([String(statusFromDashboard)]);
    }
  }, [statusFromDashboard]);
  useEffect(() => {
    if (
      showCreateForm &&
      statusList.length > 0 &&
      !isEditing &&
      !formData.status_id //  prevent overwrite
    ) {
      // 1. Try default from API
      let defaultStatus = statusList.find((s) => s.stage === 0);
      // 2. Fallback to "open"
      if (!defaultStatus) {
        defaultStatus = statusList.find((s) =>
          s.name?.toLowerCase().includes("open"),
        );
      }

      // 3. Final fallback
      if (!defaultStatus) {
        defaultStatus = statusList[0];
      }

      setFormData((prev) => ({
        ...prev,
        status_id: String(defaultStatus.id),
      }));
    }
  }, [showCreateForm, statusList, isEditing, formData.status_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "attachment") {
      const file = files[0];
      if (!file) return;

      const allowedExtensions = [
        "png",
        "jpg",
        "jpeg",
        "pdf",
        "csv",
        "xls",
        "xlsx",
      ];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      const maxSize = 10 * 1024 * 1024;

      // ✅ File type validation
      if (!allowedExtensions.includes(fileExtension)) {
        showError("Allowed files: PNG, JPG, JPEG, PDF, CSV, XLS, XLSX");
        e.target.value = "";
        return;
      }

      // ✅ File size validation (NEW)
      if (file.size > maxSize) {
        showError("File size should not exceed 10 MB");
        e.target.value = "";
        return;
      }

      // ✅ If valid
      setFormData({ ...formData, attachment: file });
    } else if (name === "type_id") {
      setFormData({
        ...formData,
        type_id: value,
        category_id: "",
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleCreateTicket = async () => {
    if (isEditing && isClosedTicket) {
      showError("This ticket is closed. You cannot update it.");
      return;
    }
    if (creating) return;
    setCreating(true);
    try {
      // 🔹 Subject
      if (!formData.subject || formData.subject.trim() === "") {
        showError("Please enter subject");
        setCreating(false);
        return;
      }

      // 🔹 Priority
      if (!formData.priority) {
        showError("Please select priority");
        setCreating(false);
        return;
      }

      // 🔹 Type
      if (!formData.type_id) {
        showError("Please select type");
        setCreating(false);
        return;
      }

      // 🔹 Category
      if (!formData.category_id) {
        showError("Please select category");
        setCreating(false);
        return;
      }

      // 🔹 Description (ADD THIS 🔥)
      if (!formData.description || formData.description.trim() === "") {
        showError("Please enter description");
        setCreating(false);
        return;
      }

      if (customFields?.some((field) => field.is_required === 1)) {
        for (let field of customFields) {
          if (field.is_required === 1) {
            const value = formData[`custom_${field.id}`];

            if (!value || value.trim() === "") {
              showError(`${field.name} is required`);
              setCreating(false);
              return;
            }
          }
        }
      }
      /* CUSTOM FIELD TYPE VALIDATION */
      for (let field of customFields) {
        if (field.status !== 1) continue;

        const value = formData[`custom_${field.id}`];

        //  Required validation
        if (field.is_required === 1 && (!value || value.trim() === "")) {
          showError(`${field.name} is required`);
          return;
        }

        if (!value) continue; // skip further checks if empty & not required

        //  Type-based validation
        switch (field.type) {
          case "email":
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
              showError(`Enter valid email for ${field.name}`);
              return;
            }
            break;

          case "number":
            if (!/^\d+$/.test(value)) {
              showError(`${field.name} must be a number`);
              return;
            }
            break;

          case "date":
            if (isNaN(Date.parse(value))) {
              showError(`Enter valid date for ${field.name}`);
              return;
            }
            break;

          case "text":
          case "textarea":
          default:
            // no restriction
            break;
        }
      }
      const payload = new FormData();

      payload.append("user_id", String(userId));
      payload.append("name", user?.username || "");
      payload.append("email", email || "");
      payload.append("subject", formData.subject);
      payload.append("priority", formData.priority);
      payload.append("type", String(formData.type_id));
      payload.append("category", String(formData.category_id));
      payload.append("status", String(formData.status_id));

      if (formData.description) {
        payload.append("description", formData.description);
      }

      if (formData.attachment) {
        payload.append("file", formData.attachment);
      }

      /* NEW FIELDS */

      if (formData.reported_user) {
        payload.append("reported_user", formData.reported_user);
      }

      if (formData.assigned_users?.length > 0) {
        const assignedUserObj = formData.assigned_users.map((id) => {
          const user = userList.find((u) => String(u.id) === String(id));

          return {
            assign_to_user_id: user?.id,
            assign_to_username: user?.name,
            assign_to_useremail: user?.email,
          };
        });

        payload.append("assigned_users", JSON.stringify(assignedUserObj));
      }
      if (customFields?.length > 0) {
        const customFieldPayload = customFields.map((field) => {
          // find existing custom field (only in edit mode)
          const existingField = selectedTicket?.custom_fields?.find(
            (cf) => String(cf.field_id) === String(field.id),
          );

          return {
            ...(isEditing && existingField ? { id: existingField.id } : {}), // ✅ ONLY for PUT
            field_id: field.id,
            value: formData[`custom_${field.id}`] || "",
          };
        });

        payload.append("custom_fields", JSON.stringify(customFieldPayload));
      }
      /* UPDATE OR CREATE */

      if (isEditing) {
        await API.put(
          `/tickets/${companyId}/${userId}/${role}/${formData.id}`,
          payload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        showSuccess("Ticket updated successfully ✅");

        setSelectedTicket((prev) => ({
          ...prev,
          subject: formData.subject,
          description: formData.description,
          priority: formData.priority,
          type: formData.type_id,
          category: formData.category_id,
          status: formData.status_id,

          assigned_users: formData.assigned_users.map((id) => {
            const u = userList.find((user) => String(user.id) === String(id));
            return {
              assign_to_user_id: u?.id,
              assign_to_username: u?.name,
              assign_to_useremail: u?.email,
            };
          }),

          custom_fields: customFields.map((field) => ({
            field_id: field.id,
            value: formData[`custom_${field.id}`] || "",
          })),
        }));
      } else {
        await API.post(`/tickets/${companyId}/${role}`, payload, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        showSuccess("Ticket created successfully ");
      }

      fetchApis();

      /* RESET FORM */

      setFormData({
        subject: "",
        description: "",
        priority: "",
        type_id: "",
        category_id: "",
        status_id: "",
        attachment: null,
        reported_user: "",
        assigned_users: [],
      });

      setIsEditing(false);
      setShowCreateForm(false);
    } catch (error) {
      console.error(error);

      //  Extract message from backend response
      const errorMessage =
        error?.response?.data?.message || // most common
        error?.response?.data?.error || // sometimes APIs use "error"
        error?.message || // fallback
        "Operation failed ❌";

      showError(errorMessage);
    } finally {
      setCreating(false);
    }
  };

  const handleCardClick = async (ticket) => {
    setSelectedTicket(ticket);
    setShowMobileRightPanel(true);
    setShowCreateForm(false);

    setShowUserDropdown(false);

    await Promise.all([fetchConversations(ticket.id), fetchExternalUsers()]);
  };
  const handlePlusClick = () => {
    let defaultStatusId = "";

    if (role === "end_user" && statusList.length > 0) {
      const openStatus = statusList.find(
        (s) => s.name.toLowerCase() === "open",
      );

      defaultStatusId = openStatus
        ? String(openStatus.id)
        : String(statusList[0].id);
    }

    // ✅ FULL RESET
    setFormData({
      subject: "",
      description: "",
      priority: "",
      type_id: "",
      category_id: "",
      status_id: defaultStatusId,
      attachment: null,
      reported_user: "",
      assigned_users: [],
    });

    setSelectedTicket(null);
    setIsEditing(false);
    setShowCreateForm(true);
    setShowMobileRightPanel(true);
  };
  const handleBackClick = () => {
    setShowMobileRightPanel(false);
    setShowCreateForm(false);
    setSelectedTicket(null);
  };
  const handleEditBack = () => {
    setShowCreateForm(false); // close edit form
    setIsEditing(false); // reset edit state
  };

  const filteredUsers = useMemo(() => {
    return userList.filter((u) =>
      u.name?.toLowerCase().trim().includes(searchTerm.toLowerCase().trim()),
    );
  }, [searchTerm, userList]);

  const selectedStatusObj = statusList.find(
    (s) => String(s.id) === String(selectedTicket?.status),
  );

  const isClosedTicket = selectedStatusObj?.stage === 1;
  const handleLoadMore = () => {
    if (loading) return; // Prevent multiple clicks while loading
    const prevHeight = listRef.current?.scrollHeight;
    setPage((prev) => prev + 1);
    setTimeout(() => {
      if (listRef.current) {
        listRef.current.scrollTop = prevHeight;
      }
    }, 200);
  };
  return (
    <div className="ticket-wrapper">
      <div className="ticket-container">
        {/* HEADER */}
        <div className="page-header">
          <div className="ticket-status-scroll">
            {/* ✅ Unassigned Button FIRST */}
            <button
              className={`ticket-status-btn ${
                isUnassigned ? "status-active" : ""
              }`}
              style={{
                backgroundColor: "#ff7d0e",
                color: "#fff",
              }}
              onClick={handleUnassignedFilter}
            >
              Unassigned
            </button>

            {/* ✅ Existing Status Buttons */}
            {statusList.map((status) => {
              const isActive = selectedStatuses.includes(String(status.id));

              return (
                <button
                  key={status.id}
                  className={`ticket-status-btn ${
                    isActive ? "status-active" : ""
                  }`}
                  style={{
                    backgroundColor: formatColor(status.colour),
                    color: "#fff",
                  }}
                  onClick={() => handleStatusFilter(String(status.id))}
                >
                  {status.name}
                </button>
              );
            })}
          </div>

          {/* RIGHT SIDE */}
          <div className="ticket-header-actions">
            <div
              className="ticket-action-btn"
              title="Refresh"
              onClick={handleRefresh}
            >
              <img src={refreshIcon} alt="refresh" />
            </div>

            {/* <div className="ticket-action-btn" title="Export">
              <img src={exportIcon} alt="export" />
            </div> */}

            <div
              className="ticket-action-btn"
              title="Filter"
              onClick={() => setShowFilterDrawer(true)}
            >
              <img src={filterIcon} alt="filter" />
            </div>

            <div
              className="ticket-action-btn primary"
              title="Create Ticket"
              onClick={handlePlusClick}
            >
              <img src={plusIcon} alt="add" />
            </div>
          </div>
        </div>

        {/* BODY */}
        <div className="ticket-body">
          <div className="row p-3">
            {/* LEFT SECTION */}
            <div
              className={`col-md-6 col-lg-6 ${showMobileRightPanel ? "mobile-hide" : ""}`}
            >
              <div className="bg-white custom-box d-flex flex-column">
                <div className="ticket-inner-body p-3" ref={listRef}>
                  {ticketList.length === 0 && loading ? (
                    <p className="text-muted">Loading tickets...</p>
                  ) : ticketList.length === 0 ? (
                    <div className="empty-state">
                      <p className="text-muted">
                        No tickets yet. Click the + button to create your first
                        ticket
                      </p>
                    </div>
                  ) : (
                    (() => {
                      const groupedTickets = ticketList.reduce(
                        (acc, ticket) => {
                          const dateKey = ticket.created_at
                            ? new Date(ticket.created_at).toDateString()
                            : "No Date";

                          if (!acc[dateKey]) acc[dateKey] = [];

                          acc[dateKey].push(ticket);
                          return acc;
                        },
                        {},
                      );

                      return Object.entries(groupedTickets).map(
                        ([date, tickets]) => {
                          const formattedDate =
                            date !== "No Date"
                              ? new Date(date).toLocaleDateString("en-US", {
                                  month: "short",
                                  day: "2-digit",
                                  year: "numeric",
                                })
                              : "No Date";

                          return (
                            <div key={date} className="date-group">
                              <div className="card-date-outside">
                                {formattedDate}
                              </div>

                              {tickets.map((ticket, index) => {
                                const statusObj = getStatusDetails(
                                  ticket.status,
                                );
                                const typeObj = getTypeDetails(ticket.type);
                                const categoryObj = getCategoryDetails(
                                  ticket.category,
                                );

                                return (
                                  <div
                                    key={index}
                                    className={`task-card mb-0 p-3 border rounded ${
                                      selectedTicket?.id === ticket.id
                                        ? "active-ticket"
                                        : ""
                                    }`}
                                    onClick={() => handleCardClick(ticket)}
                                  >
                                    {/* ✅ ROW 1 (FULLY UPDATED) */}
                                    <div className="ticket-row">
                                      {/* LEFT SIDE */}
                                      <div className="ticket-left-block">
                                        <span className="ticket-card-ticket-number">
                                          {ticket.ticket_number}
                                        </span>

                                        {/* Priority */}
                                        {ticket.priority && (
                                          <div className="d-flex align-items-center gap-1">
                                            <span
                                              className={`priority-dot ${ticket.priority.toLowerCase()}`}
                                            ></span>
                                            <span className="priority-text">
                                              {ticket.priority}
                                            </span>
                                          </div>
                                        )}

                                        {/* Type */}
                                        {typeObj && (
                                          <div className="d-flex align-items-center gap-1">
                                            <span
                                              className="status-dot"
                                              style={{
                                                backgroundColor: formatColor(
                                                  typeObj?.colour,
                                                ),
                                              }}
                                            ></span>
                                            <span className="status-text">
                                              {typeObj?.name}
                                            </span>
                                          </div>
                                        )}

                                        {/* Category */}
                                        {categoryObj && (
                                          <div className="d-flex align-items-center gap-1">
                                            <span
                                              className="status-dot"
                                              style={{
                                                backgroundColor: formatColor(
                                                  categoryObj?.colour,
                                                ),
                                              }}
                                            ></span>
                                            <span className="status-text">
                                              {categoryObj?.name}
                                            </span>
                                          </div>
                                        )}
                                      </div>

                                      <div className="ticket-right-block">
                                        <span
                                          className="ticket-card-status-badge"
                                          style={{
                                            backgroundColor: formatColor(
                                              statusObj?.colour,
                                            ),
                                            color: "#fff",
                                          }}
                                        >
                                          {statusObj?.name || "Unknown"}
                                        </span>
                                      </div>
                                    </div>

                                    {/* ROW 2 */}
                                    <div className="ticket-row">
                                      <div className="ticket-subject ticket-text-ellipsis">
                                        {ticket.subject || "-"}
                                      </div>
                                    </div>

                                    {/* ROW 3 */}
                                    <div className="ticket-row">
                                      <div className="ticket-meta-small ticket-text-ellipsis d-flex align-items-center">
                                        <span className="company-name">
                                          {ticket.company_name}
                                        </span>
                                      </div>
                                    </div>

                                    <div
                                      className="ticket-row"
                                      style={{ gap: "4px" }}
                                    >
                                      {/* LEFT SIDE */}
                                      <div className="ticket-meta-small ticket-text-ellipsis">
                                        <strong style={{ color: "#000" }}>
                                          Reported By:
                                        </strong>{" "}
                                        {ticket.name || "-"}
                                        {" | "}
                                        {ticket.assigned_users &&
                                          ticket.assigned_users.length > 0 && (
                                            <>
                                              <strong style={{ color: "#000" }}>
                                                Assigned To:
                                              </strong>{" "}
                                              {ticket.assigned_users.length <= 2
                                                ? ticket.assigned_users
                                                    .map(
                                                      (u) =>
                                                        u.assign_to_username,
                                                    )
                                                    .join(", ")
                                                : `${ticket.assigned_users
                                                    .slice(0, 2)
                                                    .map(
                                                      (u) =>
                                                        u.assign_to_username,
                                                    )
                                                    .join(", ")} ...`}
                                            </>
                                          )}
                                      </div>

                                      {/* RIGHT SIDE (TIME) */}
                                      <div className="ticket-reporter">
                                        {getTimeAgo(ticket.created_at)}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        },
                      );
                    })()
                  )}
                  {hasMore && !loading && ticketList.length > 0 && (
                    <div className="load-more-container">
                      <button
                        className="load-more-btn"
                        onClick={handleLoadMore}
                      >
                        Load More
                      </button>
                    </div>
                  )}
                  {loading && page > 1 && (
                    <div className="load-more-container">
                      <p className="text-muted">Loading more tickets...</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div
              className={`col-md-6 col-lg-6 ${!showMobileRightPanel ? "mobile-hide" : ""}`}
            >
              <div className="bg-white custom-box d-flex flex-column">
                {/* RIGHT HEADER with Back button for mobile */}
                <div
                  className={`right-box-header ${
                    showCreateForm ? "header-active" : ""
                  }`}
                >
                  {!showCreateForm && selectedTicket ? (
                    <div className="d-flex align-items-center">
                      <button
                        className="circle-back-btn d-md-none"
                        onClick={handleBackClick}
                      >
                        <img src={backIcon} alt="back" className="back-icon" />
                      </button>
                      {/* <span style={{ fontSize: "16px", marginLeft: "8px" }}>
                        Ticket Details
                      </span> */}
                    </div>
                  ) : showCreateForm ? (
                    <div className="d-flex align-items-center">
                      {showCreateForm && (
                        <button
                          className="circle-back-btn me-2"
                          onClick={handleEditBack}
                        >
                          <img
                            src={backIcon}
                            alt="back"
                            className="back-icon"
                          />
                        </button>
                      )}

                      <span style={{ fontSize: "16px" }}>
                        {isEditing ? "Update Ticket" : "Raise new ticket"}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= TICKET DETAIL VIEW ================= */}
                {!showCreateForm && selectedTicket ? (
                  <div className="ticket-detail-view">
                    <div className="ticket-detail-card">
                      {/* TOP BAR */}
                      <div className="ticket-detail-top">
                        <div className="ticket-detail-left">
                          <div className="ticket-detail-number">
                            #{selectedTicket.ticket_number}
                          </div>

                          {selectedTypeObj && (
                            <div className="d-flex align-items-center gap-1">
                              <span
                                className="status-dot"
                                style={{
                                  backgroundColor: formatColor(
                                    selectedTypeObj?.colour,
                                  ),
                                }}
                              ></span>

                              <span className="status-location">
                                {selectedTypeObj?.name}
                              </span>
                            </div>
                          )}
                        </div>

                        <div className="ticket-action-area">
                          <span
                            className="ticket-detail-status"
                            style={{
                              backgroundColor: formatColor(
                                getStatusDetails(selectedTicket.status)?.colour,
                              ),
                            }}
                          >
                            {getStatusDetails(selectedTicket.status)?.name}
                          </span>

                          <img
                            src={editIcon}
                            alt="edit"
                            className="ticket-action-icon"
                            onClick={() => {
                              if (isClosedTicket) {
                                showError("This ticket is closed");
                                return;
                              }
                              handleEditClick();
                            }}
                          />
                        </div>
                      </div>

                      {/* SUBJECT */}
                      <div className="ticket-detail-subject">
                        {selectedTicket.subject}
                      </div>

                      {/* META */}
                      <div className="ticket-detail-meta">
                        <span>
                          <strong>Category:</strong>{" "}
                          {getCategoryDetails(selectedTicket.category)?.name ||
                            "-"}
                        </span>

                        <span>
                          <strong>Priority:</strong>{" "}
                          {selectedTicket.priority || "-"}
                        </span>

                        <span>
                          <strong>Created:</strong>{" "}
                          {formatFullDate(selectedTicket.created_at)}
                        </span>
                      </div>

                      <div className="ticket-divider"></div>
                      {/* DESCRIPTION HEADER ROW */}
                      <div className="ticket-description-row">
                        <div className="ticket-description-title">
                          Description
                        </div>
                      </div>

                      {/* DESCRIPTION TEXT */}
                      <div className="ticket-detail-description">
                        {selectedTicket.description || "No description"}
                      </div>
                      {selectedTicket?.attachment && (
                        <div className="ticket-attachment-row">
                          <span className="attachment-label">Attachments</span>

                          <button
                            type="button"
                            className="attachment-link-btn"
                            onClick={handleDownloadAttachment}
                          >
                            {selectedTicket.attachment
                              ?.split("/")
                              ?.pop()
                              ?.replace(/^\d+_/, "")}{" "}
                          </button>
                        </div>
                      )}
                      {previewUrl && (
                        <div className="preview-overlay">
                          <div className="preview-container">
                            <div className="preview-header">
                              <span className="preview-title">
                                {previewFile
                                  ?.split("/")
                                  .pop()
                                  ?.replace(/^\d+_/, "")}
                              </span>

                              <div className="preview-actions">
                                <a
                                  href={previewUrl}
                                  download={previewFile}
                                  className="preview-download-btn"
                                >
                                  <img
                                    src={downloadButton}
                                    alt="download"
                                    className="preview-download-icon"
                                  />
                                </a>

                                <button
                                  className="preview-close-btn"
                                  onClick={() => {
                                    setPreviewUrl(null);
                                    setPreviewFile(null);
                                  }}
                                >
                                  <img
                                    src={closeIcon}
                                    alt="close"
                                    className="preview-close-icon"
                                  />
                                </button>
                              </div>
                            </div>

                            <div className="preview-body">
                              {isImage ? (
                                <img
                                  src={previewUrl}
                                  alt="preview"
                                  className="preview-image"
                                />
                              ) : isPdf ? (
                                <div className="file-preview-box">
                                  <img
                                    src={fileIcon}
                                    alt="pdf"
                                    className="file-preview-icon"
                                  />

                                  <p>
                                    Click the download Button to open the PDF.
                                  </p>
                                </div>
                              ) : isExcel ? (
                                <div className="file-preview-box">
                                  <img
                                    src={excelIcon}
                                    alt="excel"
                                    className="file-preview-icon"
                                  />

                                  <p>
                                    Click the download Button to open the Excel.
                                  </p>
                                </div>
                              ) : (
                                <div className="file-preview-box">
                                  <img
                                    src={fileIcon}
                                    alt="file"
                                    className="file-preview-icon"
                                  />

                                  <h3>Preview Not Supported</h3>

                                  <p>
                                    Please click the download button above to
                                    download this file.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="ticket-scroll-area">
                      {conversations.length > 0 && (
                        <div className="conversation-wrapper">
                          <h5 className="conversation-title">Conversation</h5>

                          {conversations.map((c) => (
                            <div key={c.id} className="conversation-card">
                              <div className="conversation-header">
                                <div className="conversation-name">
                                  {c.username}
                                </div>

                                <div className="conversation-time">
                                  {getTimeAgo(c.created_at)}
                                </div>
                              </div>

                              <div
                                className="conversation-message"
                                dangerouslySetInnerHTML={{
                                  __html: c.message
                                    ? c.message.replace(/\n/g, "<br>")
                                    : "",
                                }}
                              ></div>

                              {c.attachment && (
                                <div className="conversation-attachment">
                                  <div className="attachment-name">
                                    {c.attachment?.replace(/^\d+_/, "")}
                                  </div>

                                  <button
                                    className="attachment-download"
                                    onClick={() =>
                                      handleConversationDownload(
                                        c.id,
                                        c.attachment,
                                      )
                                    }
                                  >
                                    <img
                                      src={downloadIcon}
                                      alt="Download"
                                      className="download-icon"
                                    />
                                  </button>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="reply-card">
                        <div className="reply-header">
                          <h5>Add Reply</h5>
                        </div>

                        <div className="reply-body">
                          {/* TEXTAREA */}
                          <textarea
                            className="reply-textarea"
                            placeholder="Write your reply..."
                            rows="4"
                            value={replyMessage}
                            onChange={(e) => setReplyMessage(e.target.value)}
                          ></textarea>

                          {/* FILE + SEND ROW */}
                          <div className="reply-bottom-row">
                            <input
                              type="file"
                              accept=".png,.jpg,.jpeg,.pdf,.csv,.xls,.xlsx"
                              onChange={(e) =>
                                setReplyFiles([e.target.files[0]])
                              }
                            />

                            <button
                              className="reply-send-btn"
                              onClick={handleSendReply}
                              disabled={sending || isClosedTicket}
                            >
                              {sending ? "Sending..." : "Send"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : showCreateForm ? (
                  /* ================= RAISE TICKET FORM ================= */
                  <div className="ticket-detail-view">
                    <div className="raise-ticket-form">
                      <div className="form-group">
                        <label>
                          Subject <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter subject"
                          disabled={isClosedTicket}
                        />
                      </div>

                      {/* PRIORITY */}
                      <div className="form-group mb-2">
                        <label>
                          Priority <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          name="priority"
                          value={formData.priority}
                          onChange={handleChange}
                          className="form-control"
                          disabled={!canEditPriority || isClosedTicket}
                        >
                          <option value="">Select priority</option>
                          <option value="High">High</option>
                          <option value="Medium">Medium</option>
                          <option value="Low">Low</option>
                        </select>
                      </div>

                      {/* TYPE */}
                      <div className="form-group mb-2">
                        <label>
                          Type <span style={{ color: "red" }}>*</span>
                        </label>
                        {isEditing ? (
                          <input
                            className="form-control"
                            disabled={isClosedTicket}
                            value={
                              typeList.find(
                                (t) =>
                                  String(t.id) === String(formData.type_id),
                              )?.name || ""
                            }
                            readOnly
                          />
                        ) : (
                          <select
                            name="type_id"
                            value={formData.type_id}
                            onChange={handleChange}
                            className="form-control"
                            disabled={isClosedTicket}
                          >
                            <option value="">Select type</option>
                            {typeList.map((t) => (
                              <option key={t.id} value={t.id}>
                                {t.name}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>

                      {/* CATEGORY */}
                      <div className="form-group mb-2">
                        <label>
                          Category <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          name="category_id"
                          value={formData.category_id}
                          onChange={handleChange}
                          className="form-control"
                          disabled={isClosedTicket}
                        >
                          <option value="">Select category</option>
                          {filteredCategories.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {isEditing && (
                        <div className="form-group mb-2">
                          <label>
                            Status <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            name="status_id"
                            value={formData.status_id || ""}
                            onChange={handleChange}
                            className="form-control"
                            disabled={isClosedTicket}
                          >
                            <option value="">Select status</option>
                            {filteredStatus.map((s) => (
                              <option key={s.id} value={s.id}>
                                {s.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {/* ================= CUSTOM FIELDS ================= */}
                      {customFields
                        ?.filter((field) => field.status === 1)
                        ?.sort((a, b) => a.field_order - b.field_order)
                        ?.map((field) => (
                          <div className="form-group mb-2" key={field.id}>
                            <label>
                              {field.name}
                              {field.is_required === 1 && (
                                <span style={{ color: "red" }}> *</span>
                              )}
                            </label>
                            {field.type === "textarea" ? (
                              <textarea
                                className="form-control"
                                placeholder={field.placeholder || field.name}
                                value={formData[`custom_${field.id}`] || ""}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    [`custom_${field.id}`]: e.target.value,
                                  }))
                                }
                              />
                            ) : (
                              <input
                                type={field.type || "text"}
                                className="form-control"
                                placeholder={field.placeholder || field.name}
                                value={formData[`custom_${field.id}`] || ""}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    [`custom_${field.id}`]: e.target.value,
                                  }))
                                }
                                disabled={isClosedTicket}
                              />
                            )}
                          </div>
                        ))}
                      {isEditing && !hideAssignUsers && (
                        <div className="form-group mb-2">
                          <label>Assign Users</label>

                          <div className="assign-dropdown">
                            <div
                              className="assign-input"
                              onClick={() => {
                                if (!canEditAssignedUsers || isClosedTicket)
                                  return;
                                setShowUserDropdown(!showUserDropdown);
                              }}
                            >
                              {formData.assigned_users.length === 0
                                ? "Select User"
                                : userList
                                    .filter((u) =>
                                      formData.assigned_users.includes(
                                        String(u.id),
                                      ),
                                    )
                                    .map((u) => u.name)
                                    .join(", ")}
                            </div>

                            {showUserDropdown && (
                              <div className="assign-dropdown-menu">
                                <div className="search-container">
                                  <input
                                    type="text"
                                    placeholder="Search users..."
                                    value={searchTerm}
                                    onChange={(e) =>
                                      setSearchTerm(e.target.value)
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                    className="assign-search-input"
                                    autoFocus
                                  />
                                </div>

                                {filteredUsers.length > 0 ? (
                                  filteredUsers.map((u) => {
                                    const isSelected =
                                      formData.assigned_users.includes(
                                        String(u.id),
                                      );

                                    return (
                                      <div
                                        key={u.id}
                                        className="assign-user-row"
                                        onClick={() => {
                                          if (!canEditAssignedUsers) return;

                                          if (isSelected) {
                                            setFormData({
                                              ...formData,
                                              assigned_users:
                                                formData.assigned_users.filter(
                                                  (id) => id !== String(u.id),
                                                ),
                                            });
                                          } else {
                                            setFormData({
                                              ...formData,
                                              assigned_users: [
                                                ...formData.assigned_users,
                                                String(u.id),
                                              ],
                                            });
                                          }
                                        }}
                                      >
                                        <span>{u.name}</span>

                                        <span
                                          className={`circle ${isSelected ? "active" : ""}`}
                                        >
                                          {isSelected && "✓"}
                                        </span>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="no-user-found">
                                    No users found
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {/* ATTACHMENT */}
                      {!isEditing && (
                        <div className="form-group mb-2">
                          <label>Attachment</label>
                          <input
                            type="file"
                            name="attachment"
                            accept=".png,.jpg,.jpeg,.pdf,.csv,.xls,.xlsx"
                            onChange={handleChange}
                            className="form-control"
                            disabled={isClosedTicket}
                          />
                        </div>
                      )}
                      {/* DESCRIPTION */}
                      <div className="form-group mb-2">
                        <label>
                          Description <span style={{ color: "red" }}>*</span>
                        </label>
                        <textarea
                          rows="4"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          className="form-control"
                          disabled={isClosedTicket}
                        />
                      </div>

                      <button
                        className="create-btn mt-2"
                        onClick={handleCreateTicket}
                        disabled={creating || isClosedTicket}
                      >
                        {creating
                          ? isEditing
                            ? "Updating..."
                            : "Submitting..."
                          : isEditing
                            ? "Update Ticket"
                            : "Submit"}
                      </button>
                    </div>
                  </div>
                ) : (
                  /* ================= DEFAULT MESSAGE ================= */
                  <div className="d-flex flex-column justify-content-center align-items-center text-center h-100 p-3">
                    <img
                      src={clickIcon}
                      alt="click"
                      className="mb-2 img-fluid"
                      style={{ width: "36px", opacity: "0.7" }}
                    />
                    <p className="text-muted fw-light mb-0">
                      Click a card on the left <br />
                      to display its details here
                    </p>
                  </div>
                )}
              </div>
            </div>
            {showFilterDrawer && (
              <div className="filter-overlay">
                <div className="filter-drawer">
                  {/* HEADER */}
                  <div className="filter-header">
                    <span>Filters</span>
                    <span onClick={() => setShowFilterDrawer(false)}>✕</span>
                  </div>

                  {/* CUSTOMER (ONLY FOR SPECIFIC ROLES) */}
                  {(role === "super_admin" ||
                    role === "support_admin" ||
                    role === "support_agent") && (
                    <div className="form-group">
                      <label>Customer</label>
                      <select
                        className="form-control"
                        value={filters.customer}
                        onChange={(e) =>
                          setFilters({ ...filters, customer: e.target.value })
                        }
                      >
                        <option value="">All Customers</option>

                        {companyList.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.company_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* TYPE (VISIBLE FOR ALL) */}
                  <div className="form-group">
                    <label>Type</label>
                    <select
                      className="form-control"
                      value={filters.type}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          type: e.target.value,
                          category: "", // reset category
                        })
                      }
                    >
                      <option value="">All Modules</option>
                      {typeList.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* ✅ CATEGORY (ONLY SHOW WHEN TYPE IS SELECTED) */}

                  <div className="form-group">
                    <label>Category</label>

                    <select
                      className="form-control"
                      value={filters.category}
                      disabled={!filters.type}
                      onChange={(e) =>
                        setFilters({ ...filters, category: e.target.value })
                      }
                    >
                      {!filters.type ? (
                        <option value="">Select type first</option>
                      ) : (
                        <>
                          <option value="">All Categories</option>
                          {categoryList
                            .filter(
                              (c) => String(c.type_id) === String(filters.type),
                            )
                            .map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.name}
                              </option>
                            ))}
                        </>
                      )}
                    </select>
                  </div>

                  {/* PRIORITY (VISIBLE FOR ALL) */}
                  <div className="form-group">
                    <label>
                      Priority <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control"
                      value={filters.priority}
                      onChange={(e) =>
                        setFilters({ ...filters, priority: e.target.value })
                      }
                    >
                      <option value="">All</option>
                      <option value="High">High</option>
                      <option value="Medium">Medium</option>
                      <option value="Low">Low</option>
                      <option value="showstopper">Show stopper</option>
                    </select>
                  </div>

                  {/* APPLY BUTTON */}
                  <div className="filter-actions">
                    <button
                      className="apply-filter-btn"
                      onClick={() => {
                        setAppliedFilters(filters);
                        setShowFilterDrawer(false);
                        setPage(1);
                        setHasMore(true);
                        setTicketList([]);
                      }}
                    >
                      Apply Filters
                    </button>

                    <button
                      className="clear-filter-btn"
                      onClick={handleClearFilters}
                    >
                      Clear All
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
